import React from 'react';
import { Center, Grid, GridItem, Stack } from '@fiverr-private/layout_components';
import { Content } from '../Content';
import { Truncate } from '../Truncate';
import FiverrFreelancers from './FiverrFreelancers/FiverrFreelancers';
import { contentContainer } from './styles.ve.css';

interface HowToHireProps {
    content: string;
}

export const HowToHire = ({ content }: HowToHireProps) => (
    <Grid
        templateColumns={{
            default: '100%',
            sm: '100%',
            md: '50%_50%',
            lg: '50%_50%',
            xl: '50%_50%',
        }}
    >
        <GridItem>
            <Stack direction="column" className={contentContainer}>
                <Truncate>
                    <Content className={contentContainer} isIndependent={true} plainHtml={content} />
                </Truncate>
            </Stack>
        </GridItem>

        <GridItem>
            <Center padding="0">
                <FiverrFreelancers />
            </Center>
        </GridItem>
    </Grid>
);
